/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import {
  Col,
  Row,
  Spinner,
  Typography,
} from '@airbus/components-react';
import { COMBOBOX_PLACEHOLDER } from '../../../utils/constants';
import AdvanceComboBox from '../AdvanceComboBox/AdvanceComboBox';
import './GenericColumnLevelFilter.scss';

const ColumnLevelFilter: any = (props: any) => {
  const { filterProps, updateConditionsObj } = props;
  return (
    <Row className="data-filter-row">
      {filterProps?.filterColumns?.columnProps.map((item: any) => (
        <>
          <Col xxs={3} className="data-filter-label">
            <Typography variant="small" className="filter-column-color">
              {item.Header}
            </Typography>
          </Col>
          <Col xxs={1}>
            {item.isLoading && <Spinner className="spinner-align" />}
          </Col>

          <Col xxs={8} className="dynamic-header-outside">
            <AdvanceComboBox
              loadOptions={item.loadOptions}
              placeholder={COMBOBOX_PLACEHOLDER}
              disabled={typeof item.isLoading === 'undefined' ? false : item.isLoading}
              id={`ACB-checker-filter-${item.id}`}
              className="checker-details-fin-combo-box"
              filterOptions={item.storeVariable}
              loading={item.isLoading}
              applyHandler={(selected: Array<any>) => {
                updateConditionsObj({ [item.filterName]: selected });
                if (item.selectionHandler) {
                  item.selectionHandler({ [item.filterName]: selected });
                }
              }}
              searchPattern={item.id === 'ata' ? 'startsWith' : 'contains'}
              sortOptions={item.id === 'ata'}
            />
          </Col>
        </>
      ))}
    </Row>
  );
};

export default ColumnLevelFilter;
